import moment from "moment";
import { createKey } from "../../../../../Shared/utils/createKey";
/**
 * Creates a recipe assignment object based on the provided parameters.
 *
 * @param CreateAssignmentParams
 * @returns RecipeAssignment
 */
export const createRecipeAssignment = ({ recipe, currentAssignmentQuantity, programMealId, selectedDay, recipeAssignment, }) => {
    var _a, _b, _c;
    return {
        RecipeId: recipe.RecipeId,
        RecipeName: recipe.RecipeName,
        Quantity: currentAssignmentQuantity,
        ProgramMealId: programMealId,
        Date: moment(selectedDay),
        RecipeShortName: recipe.RecipeShortName,
        SelectedIngredientOptions: (_a = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.SelectedIngredientOptions) !== null && _a !== void 0 ? _a : [],
        RecipePrice: (_b = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _b !== void 0 ? _b : 0,
        RecipeAssignmentPrice: (_c = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _c !== void 0 ? _c : 0,
        IsAutomaticSelection: false,
        CompatibilityType: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType,
        AutomaticReplacements: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.AutomaticReplacements,
        Skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
        AssignmentId: createKey(),
    };
};
